import React from 'react'
import Input from '../../../../shared/component/inputFields'

const ContractInfo = () => {
  return (
    <div className='contractInfo'>
      <h1 className='title'>Activities</h1>
              <div className='row'>
            <div className='col-lg-6 col-md-6'>
            <div className='box-check'>
                  <h1 className='title'>Activities</h1>
                  <div className='all-check'>
                      <label className='check' htmlFor='all'>
                        <input type="checkbox" id="all"/>
                        <span>Select All</span>
                      </label>
                      <label className='check' htmlFor='Simply'>
                        <input type="checkbox" id="Simply"/>
                        <span>Lorem Ipsum Is Simply Dummy Text</span>
                      </label>
                      <label className='check' htmlFor='Printing'>
                        <input type="checkbox" id="Printing"/>
                        <span>Of The Printing And Typesetting Industry.</span>
                      </label>
                      <label className='check' htmlFor='Printing'>
                        <input type="checkbox" id="Printing"/>
                        <span>Of The Printing And Typesetting Industry.</span>
                      </label>
                      <label className='check' htmlFor='Printing'>
                        <input type="checkbox" id="Printing"/>
                        <span>Of The Printing And Typesetting Industry.</span>
                      </label>
                      <label className='check' htmlFor='Printing'>
                        <input type="checkbox" id="Printing"/>
                        <span>Of The Printing And Typesetting Industry.</span>
                      </label>
                      <label className='check' htmlFor='Printing'>
                        <input type="checkbox" id="Printing"/>
                        <span>Of The Printing And Typesetting Industry.</span>
                      </label>
                  </div>
              </div>
            </div>
            <div className='col-lg-6 col-md-6'>
            <div className='box-check'>
                  <h1 className='title'>Vehicle Type</h1>
                  <div className='all-check'>
                      <label className='check' htmlFor='all'>
                        <input type="checkbox" id="all"/>
                        <span>Select All</span>
                      </label>
                      <label className='check' htmlFor='Simply'>
                        <input type="checkbox" id="Simply"/>
                        <span>Lorem Ipsum Is Simply Dummy Text</span>
                      </label>
                      <label className='check' htmlFor='Printing'>
                        <input type="checkbox" id="Printing"/>
                        <span>Of The Printing And Typesetting Industry.</span>
                      </label>
                      <label className='check' htmlFor='Printing'>
                        <input type="checkbox" id="Printing"/>
                        <span>Of The Printing And Typesetting Industry.</span>
                      </label>
                      <label className='check' htmlFor='Printing'>
                        <input type="checkbox" id="Printing"/>
                        <span>Of The Printing And Typesetting Industry.</span>
                      </label>
                      <label className='check' htmlFor='Printing'>
                        <input type="checkbox" id="Printing"/>
                        <span>Of The Printing And Typesetting Industry.</span>
                      </label>
                      <label className='check' htmlFor='Printing'>
                        <input type="checkbox" id="Printing"/>
                        <span>Of The Printing And Typesetting Industry.</span>
                      </label>
                  </div>
                </div>
            </div>
            <div className='col-lg-6 col-md-6'>
            <div className='box-check'>
                  <h1 className='title'>From</h1>
                  <div className='all-check'>
                      <label className='check' htmlFor='all'>
                        <input type="checkbox" id="all"/>
                        <span>Select All</span>
                      </label>
                      <label className='check' htmlFor='Simply'>
                        <input type="checkbox" id="Simply"/>
                        <span>Lorem Ipsum Is Simply Dummy Text</span>
                      </label>
                      <label className='check' htmlFor='Printing'>
                        <input type="checkbox" id="Printing"/>
                        <span>Of The Printing And Typesetting Industry.</span>
                      </label>
                      <label className='check' htmlFor='Printing'>
                        <input type="checkbox" id="Printing"/>
                        <span>Of The Printing And Typesetting Industry.</span>
                      </label>
                      <label className='check' htmlFor='Printing'>
                        <input type="checkbox" id="Printing"/>
                        <span>Of The Printing And Typesetting Industry.</span>
                      </label>
                      <label className='check' htmlFor='Printing'>
                        <input type="checkbox" id="Printing"/>
                        <span>Of The Printing And Typesetting Industry.</span>
                      </label>
                      <label className='check' htmlFor='Printing'>
                        <input type="checkbox" id="Printing"/>
                        <span>Of The Printing And Typesetting Industry.</span>
                      </label>
                  </div>
              </div>
            </div>
            <div className='col-lg-6 col-md-6'>
            <div className='box-check'>
                  <h1 className='title'>to</h1>
                  <div className='all-check'>
                      <label className='check' htmlFor='all'>
                        <input type="checkbox" id="all"/>
                        <span>Select All</span>
                      </label>
                      <label className='check' htmlFor='Simply'>
                        <input type="checkbox" id="Simply"/>
                        <span>Lorem Ipsum Is Simply Dummy Text</span>
                      </label>
                      <label className='check' htmlFor='Printing'>
                        <input type="checkbox" id="Printing"/>
                        <span>Of The Printing And Typesetting Industry.</span>
                      </label>
                      <label className='check' htmlFor='Printing'>
                        <input type="checkbox" id="Printing"/>
                        <span>Of The Printing And Typesetting Industry.</span>
                      </label>
                      <label className='check' htmlFor='Printing'>
                        <input type="checkbox" id="Printing"/>
                        <span>Of The Printing And Typesetting Industry.</span>
                      </label>
                      <label className='check' htmlFor='Printing'>
                        <input type="checkbox" id="Printing"/>
                        <span>Of The Printing And Typesetting Industry.</span>
                      </label>
                      <label className='check' htmlFor='Printing'>
                        <input type="checkbox" id="Printing"/>
                        <span>Of The Printing And Typesetting Industry.</span>
                      </label>
                  </div>
              </div>
            </div>
            <div className='col-lg-6 col-md-6'>
              <h1 className='title'> Payment info</h1>
              <Input type="select" label="Billing type:" />
              <Input type="text" label="Number of shipments:" />
              <Input type="select" label="billing period/Day:" />
              <Input type="text" label="Demand Limit:" />
              <Input type="text" label="Discount Percentage:" value="30%" readonly/>
            </div>
            </div>

            <div className='action'>
                <div className='container'>
                    <button className='btn-border-blue'>Cancel</button>
                    <button className='btn-blue'>Request Data Change</button>
                </div>
            </div>
    </div>
  )
}

export default ContractInfo